<block-ui [name]="'ajaxCall'" [delayStart]="0" [delayStop]="500" [template]="blockUITemplate">
    <router-outlet>

    </router-outlet>
</block-ui>

<ng-template #blockUITemplate>
    <div class="w-100 text-gray" style="height: 100vh; display: flex; justify-content: center; align-items: center;">
        <img src="/images/loader.gif" draggable="false" />
    </div>
</ng-template>

<notifier-container></notifier-container>